module.exports = __webpack_public_path__ + "html/register.e5ddf2.html";


/*****************
 ** WEBPACK FOOTER
 ** ../AccountApp/register.html
 ** module id = 703
 ** module chunks = 1
 **/